import { createSlice } from '@reduxjs/toolkit';
import { NAVERWORKS_DRIVE_TYPE } from '../../define/naverworksDefine';
import { createSelectorFn } from './common';

const initialState = {
  userFullName: '',
  userEmail: '',
  isConnected: false,
  isNaverWorksFile: false,
  naverWorksFileInfo: {
    driveType: NAVERWORKS_DRIVE_TYPE.PERSONAL,
    driveId: 'me',
    folderId: '',
    fileId: ''
  }
};

const naverWorksDataSlice = createSlice({
  name: 'naverWorksData',
  initialState,
  reducers: {
    initNaverWorksData: () => initialState,
    setNaverWorksData: (state, action) => {
      state.userFullName = action.payload.userFullName;
      state.userEmail = action.payload.userEmail;
      state.isConnected = true;
    },
    setNaverWorksFileInfo: (state, action) => {
      state.isNaverWorksFile = true;
      state.naverWorksFileInfo.driveType =
        action.payload.driveType || NAVERWORKS_DRIVE_TYPE.PERSONAL;
      state.naverWorksFileInfo.driveId = action.payload.driveId || 'me';
      state.naverWorksFileInfo.folderId = action.payload.folderId;
      state.naverWorksFileInfo.fileId = action.payload.fileId;
    }
  }
});

export const { initNaverWorksData, setNaverWorksData, setNaverWorksFileInfo } =
  naverWorksDataSlice.actions;
export const useNaverWorksDataSliceSelector = createSelectorFn(naverWorksDataSlice);
export default naverWorksDataSlice;
